import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomerFacade } from '../facades/customer.facade';
import { EUserRoles } from '../configurations/common';

@Injectable({
  providedIn: 'root',
})
export class BusinessPartnersAccessGuard implements CanActivate {
  private readonly unsubscribe$: Subject<void> = new Subject<void>();
  private readonly customerFacade: CustomerFacade = inject(CustomerFacade);
  private readonly router: Router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot):
    Observable<boolean | UrlTree | RedirectCommand> | Promise<boolean | UrlTree | RedirectCommand> | boolean | UrlTree | RedirectCommand {
    if (!this.selectCustomerCompanyRoles()) {
      this.router.navigateByUrl(route.params['lang']).then();
      return false;
    }
    return true;
  }

  selectCustomerCompanyRoles(): boolean {
    let hasApprovalAccess: boolean = false;
    this.customerFacade.getCustomerCompanyRoles().pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe((roles: EUserRoles[]) => {
      hasApprovalAccess = this.checkRolesForAccess(roles);
    });
    return hasApprovalAccess;
  }

  checkRolesForAccess(roles: EUserRoles[]): boolean {
    return roles.includes(EUserRoles.BusinessPartnerBuyer) || roles.includes(EUserRoles.BusinessPartnerApprover);
  }
}
